import React from 'react';
import { Card } from './ui/Card';
import { TrendingUp, Users, Building2, Target } from 'lucide-react';
export function CareerImpact() {
  const metrics = [{
    value: '$35M',
    label: 'Division Growth',
    description: 'Built TaylorMade B2B division from $1.8M in 36 months',
    icon: <TrendingUp className="w-6 h-6 text-gold" data-id="element-64" />
  }, {
    value: '13X',
    label: 'Revenue Expansion',
    description: 'Delivered exponential YoY growth at MITO Material Solutions',
    icon: <Target className="w-6 h-6 text-gold-light" data-id="element-65" />
  }, {
    value: '$700M+',
    label: 'Asset Acquisition',
    description: 'Structured enterprise partnerships with Schwab & TD Ameritrade',
    icon: <Building2 className="w-6 h-6 text-gold" data-id="element-66" />
  }, {
    value: 'National',
    label: 'Sales Leadership',
    description: 'Built and scaled high-performing national sales teams',
    icon: <Users className="w-6 h-6 text-gold-light" data-id="element-67" />
  }];
  return <section id="impact" className="py-24 bg-navy-950 relative" data-id="element-68">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-[0.02]" data-id="element-69"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-70">
        <div className="mb-16 md:text-center" data-id="element-71">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-72">
            Quantifiable <span className="text-gradient" data-id="element-73">Impact</span>
          </h2>
          <p className="text-lg text-white/50 max-w-2xl mx-auto" data-id="element-74">
            A track record of delivering transformative revenue results across
            SaaS, advanced materials, sports, and consumer sectors.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-75">
          {metrics.map((metric, index) => <Card key={index} hover className="p-8 border-t-4 border-t-navy-700 hover:border-t-gold transition-colors" data-id="element-76">
              <div className="w-12 h-12 rounded-lg bg-navy-800/80 flex items-center justify-center mb-6" data-id="element-77">
                {metric.icon}
              </div>
              <div className="text-4xl lg:text-5xl font-bold text-gold mb-2 tracking-tight" data-id="element-78">
                {metric.value}
              </div>
              <div className="text-lg font-semibold text-white mb-3" data-id="element-79">
                {metric.label}
              </div>
              <p className="text-sm text-white/50 leading-relaxed" data-id="element-80">
                {metric.description}
              </p>
            </Card>)}
        </div>
      </div>
    </section>;
}